module.exports = __webpack_public_path__ + "static/media/openup_poster.5524fdfd.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/openup_poster.png
// module id = 361
// module chunks = 0